<script setup>
defineProps({ id: String, scale: { type: Number, default: 1 } })
</script>
<template>
  <pattern
    :id="id"
    width="5.657"
    height="5.657"
    patternUnits="userSpaceOnUse"
    :patternTransform="`scale(${scale})`"
  >
    <path
      d="M-1 4.657 L1 6.657 M0 0 L5.657 5.657 M4.657 -1 L6.657 1"
      stroke="var(--facet-stripe)"
      stroke-width="1"
      fill="none"
    />
  </pattern>
</template>
